// src/components/layout/MainLayout.jsx
import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Navbar from "./navbar";
import Footer from "./Footer";
// import Circle from "./Circle";
// import Topbar from "./TopBar";
import CartDrawer from "../common/CartDrawer";
import { useCart } from "../../Context/Cartcontext";


const MainLayout = () => {
  const { cartItems, cartOpen, setCartOpen, removeFromCart, updateQty } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Sticky wrapper — TopBar + Header + Navbar sab sticky hain */}
      {/* <Topbar /> */}
      <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Navbar mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} cartItems={cartItems} onRemove={removeFromCart} updateQty={updateQty} />

     

      <main className="flex-1 w-full">
        <Outlet />
      </main>

      <Footer />
     
    </div>
  );
};

export default MainLayout;